import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import { status } from "@/utils/common";

export default {
    namespaced: true,
    state: {
        purchaseOrders: [],
        purchaseOrder: {
            id: null,
            orderNo: null,
            invoiceNo: null,
            supplierName: null,
            receivedDate: null,
            medicines :[],
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.purchaseOrders.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.purchaseOrders = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.purchaseOrder = viewData,
        ADD: (state, addedData) => state.purchaseOrders.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.purchaseOrders.splice(index, 1, updateData),
        DELETE: (state, index) => state.purchaseOrders.splice(index, 1),
        approval: (state, index) => state.purchaseOrders[index].status = status.active,

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");
                    const response = await dataService.purchaseOrders.getAll(paramsString);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEMS', response.data.purchaseOrders);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_ITEM', {});
                const response = await dataService.purchaseOrders.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEM', response.data.purchaseOrder);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
         async getForEdit(_, id) {
            startLoading()
            try {
                const response = await dataService.purchaseOrders.getForEdit(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.purchaseOrder);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async add({ commit }, payload) {
               try {
                   startLoading()
                   const response = await dataService.purchaseOrders.add(payload);
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
       
                   showNotification(response.data.message);
                   commit("ADD", response.data.purchaseOrder);
       
       
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
                   return Promise.reject(error);
               }
           },

        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.purchaseOrders.edit(id,payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.purchaseOrder });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async delete({ commit, getters }, id) {
                startLoading()
                try {
                    const response = await dataService.purchaseOrders.delete(id);
                    stopLoading();
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
                    showNotification(response.data.message);
        
                    const index = getters.index(id);
                    commit('DELETE', index);
        
                } catch (error) {
                    stopLoading()
                    catchHandler(error);
                }
            },
        async approval({ commit, getters }, id) {
               try {
                   startLoading()
                   const response = await dataService.purchaseOrders.approval(id);
                   stopLoading()
                   if (!response.data.statusCode) {
                       showAlert(serverErrorMessage);
                       return;
                   }
                   showNotification(response.data.message);
                   const index = getters.index(id);
                   commit("approval", index);
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
               }
           },
    },
};
